/** Shared status pill styles for logical / virtual warehouse lists. */
export const WAREHOUSE_LIST_STATUS_TAG_STYLE: Record<string, string> = {
  'font-size': '0.75rem',
  'font-weight': '400',
  padding: '0.25rem 0.5rem',
  'border-radius': '9999px',
  'min-width': '80px',
  'text-align': 'center',
};

export type WarehouseStatusI18nPrefix =
  | 'logical_warehouse'
  | 'virtual_warehouse';

type TranslateFn = (key: string) => string;

export function warehouseListStatusDisplayText(
  translate: TranslateFn,
  prefix: WarehouseStatusI18nPrefix,
  status: boolean,
): string {
  return status
    ? translate(`${prefix}.status.active`)
    : translate(`${prefix}.status.inactive`);
}

export function warehouseListStatusSeverity(status: boolean): string {
  return status ? 'success' : 'secondary';
}
